import { TrackingAction, TrackingContext } from 'src/boot/plausible'
import { AbstractEntity } from 'src/entities/AbstractEntity'
import { RouteLocationRaw } from 'vue-router'
import { ROUTE_NAME_VIEW } from 'src/router/routes'
import { Feature } from 'src/services/PermissionService'
import { useInventoryStore } from 'stores/inventory-store'

export class SectorEntity extends AbstractEntity {
  // FIXME: Set default icon for sectors
  protected readonly defaultIcon: string = 'spi-building'
  protected readonly requiredFeatures : Feature[] = ['displayLists']

  public getNameFromInventory (): string {
    return useInventoryStore().getSectorNameById(this.id) || ''
  }

  public getIcon (): string {
    return useInventoryStore().getSectorIconById(this.id) || this.defaultIcon
  }

  public getSubType (): string {
    return ''
  }

  public getTrackingAction (): TrackingAction {
    return TrackingAction.OPEN_VIEW
  }

  public getTrackingContext (): TrackingContext {
    return { sectorName: this.getName(), sectorId: this.id }
  }

  public getRouteOptions (): RouteLocationRaw {
    return { name: ROUTE_NAME_VIEW, query: { sector: [this.id] } }
  }
}
